import React, {useContext} from "react";
import {VFSElement} from "../data/VFSElement";
import {useLiveQuery} from "dexie-react-hooks";
import {webDB} from "../webapi/WebAPIDB";
import {ArdaiAPIContext} from "../webapi/WebAPI";
import {ArdaiAPIStateContext} from "../ArdaiMain";
import {VFSElementCard} from "../components/VFSElementCard";
import {MobileProjectWorkspaceLayout} from "../components/MobileProjectWorkspaceLayout";
import {ListItem} from "./ListItem";
import {
    DeleteRounded, EditRounded, FolderRounded,
    MoreHorizRounded,
    MoreVertRounded,
    SelectAllRounded,
    SettingsRounded,
    TagRounded
} from "@mui/icons-material";
import {jsx} from "@emotion/react";
import JSX = jsx.JSX;
import {Tooltip} from "react-tooltip";
import {ControlledMenu, Menu} from "@szhsin/react-menu";
import {ButtonModalCompound} from "../components/ButtonModalCompound";
import {MenuButton} from "../components/MenuButton";
import {StyledModal} from "../components/StyledModal";
import {Grid} from "../../triton/components/layouts/Grid";
import {ButtonBase, ButtonVariant} from "../../triton/components/buttons/ButtonBase";
import styled from "styled-components";
import {Formik} from "formik";
import {FormElement} from "../../triton/components/forms/FormElement";
import {FormikSingleLineInput} from "../../triton/components/forms/FormikSingleLineInput";
import {ProjectListItem} from "./ProjectListItem";
import {CircularProgress} from "@mui/material";
import Collapse from "@mui/material/Collapse";
import {DescriptiveTypography} from "../../triton/components/typography/DescriptiveTypography";
import {TransitionGroup} from "react-transition-group";

const StyledProjectListView = styled.div`
  display: grid;
  gap: 2px;
  height: min-content;

  .project-view-main {

    .project-view-toolbar {
      padding-left: 8px;
    }
  }
`;

export type ProjectListViewProps = {
    path: string,
    expanded: boolean
}

export const ProjectListView: React.FC<ProjectListViewProps> = props => {
    const api = useContext(ArdaiAPIContext);
    const state = useContext(ArdaiAPIStateContext);

    let projects = useLiveQuery(async () => {
        return webDB.vfsElements
            .where("path")
            .equals(props.path)
            .and(e => e.type === "project")
            .toArray();
    }, [props.path]);

    if (projects === undefined) {
        // TODO: Better loading animation? Or just blank JSX?
        return (
            <div children={
                <ListItem title={"Loading"} icon={
                    // TODO: Add better loading icon -> Make standalone component
                    // <CircularProgress variant={"indeterminate"}/>
                    undefined
                }/>
            }/>
        );
    }

    return (
        <StyledProjectListView>
            <TransitionGroup>
                { props.expanded && (
                    <Collapse>
                        <div className={"project-view-main"}>
                            <div className={"project-view-toolbar"}>
                                <DescriptiveTypography text={"Toolbar is here lol"}/>
                            </div>

                            <TransitionGroup>
                                { projects?.length === 0 && (
                                    <Collapse>
                                        <div style={{
                                            width: "100%",
                                            padding: "1rem",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: 8
                                        }}>
                                            <DescriptiveTypography text={"Empty"}/>
                                        </div>
                                    </Collapse>
                                ) }

                                {

                                    projects?.sort((a, b) => a.title < b.title ? -1 : 1).map(e => (
                                        <Collapse key={e.id}>
                                            <ProjectListItem vfsElem={e}/>
                                        </Collapse>
                                    ))
                                }
                            </TransitionGroup>
                        </div>
                    </Collapse>
                ) }
            </TransitionGroup>
        </StyledProjectListView>
    );
}
